import {PageLink} from '../../_metronic/layout/core'
import {Navigation} from '../../components/Navigation'
import useMeta from '../../hook/useMeta'
import ProductBadges from './layouts/ProductBadges'

const productBadgesPageBreadcrumbs: PageLink[] = [
  {
    title: 'Products',
    path: '/products/all-products/all',
    isActive: false,
  },
]

const ProductBadgesPage = () => {
  useMeta('Product Badges')

  return (
    <Navigation
      baseUrl={'/products/product-badges'}
      breadcrumbs={productBadgesPageBreadcrumbs}
      navigationData={[
        {
          key: 'product-badges',
          label: 'Product Badges',
          component: <ProductBadges />,
        },
      ]}
    />
  )
}
export default ProductBadgesPage
